import Vue from 'vue'
import { formatDate } from './index'
Vue.prototype.global = {
  formatNumber(val, number) {
    if (val === '0' || val === 0) {
      return 0
    }
    if (!val) {
      return '-'
    }
    if (typeof val === 'number' && !isNaN(val)) {
      const newVal = Number(val).toFixed(number)
      return parseFloat(newVal)
    } else {
      return val
    }
  },
  setTimeInterval(obj, startTimeName, endTimeName) {
    if (!obj[startTimeName] && !obj[endTimeName]) {
      let date = new Date()
      obj[endTimeName] = formatDate(date, 'yyyy-MM-dd HH:mm:ss')
      let hour = date.getHours()
      if (hour < 8) {
        date = date.setDate(date.getDate() - 1)
        date = new Date(date)
      }
      obj[startTimeName] = formatDate(date, 'yyyy-MM-dd 08:00:00')
    }
  }
}
